module.exports = __webpack_public_path__ + "img/plume.1a6d67dd.png";